<template>
  <div class="Promotionrevenue" v-loading="loading">
    <el-form ref="form" label-width="100px" class="Forms">
      <el-row style="width:900px;">
        <el-col :span="8">
          <el-form-item label="收益账户：">
            <span v-if="this.accountData!==null">{{this.accountData.accountNumber}}</span>
            <span v-if="this.accountData==null">暂无账户</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
            <el-form-item label="收益户行：">
              <span v-if="this.accountData!==null">{{this.accountData.bank}}</span>
              <span v-if="this.accountData==null">暂无收益户行</span>
            </el-form-item>
        </el-col>
        <el-col :span="2">
            <el-form-item class="Zbutton">
              <el-button type="primary" @click="Reimbursement = true" v-if="this.accountData === null">账户</el-button>
              <el-button type="primary" @click="EditAccount" v-if="this.accountData !== null">编辑</el-button>
            </el-form-item>
        </el-col>
        <el-col :span="4">
            <el-form-item label="推广公司数：">{{this.numberOfPromotionCompanies}}</el-form-item>
          </el-col>
      </el-row>

      <el-row>
          <el-col :span="5">
            <el-form-item label="公司选择：">
              <el-select placeholder="选择公司" v-model="ruleForm.value">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.companyFullName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
                <el-form-item label="开始日期" prop="starttime">
                    <el-date-picker
                            class="width1"
                            v-model="ruleForm.starttime"
                            type="date"
                            placeholder="选择开始日期"
                            @change="startDate"
                    ></el-date-picker>
                </el-form-item>
          </el-col>
          <el-col :span="5">
                <el-form-item label="结束日期" prop="Jieshutime">
                    <el-date-picker
                            class="width1"
                            v-model="ruleForm.endtime"
                            type="date"
                            placeholder="选择结束日期"
                            @change="endDate"
                    ></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item class="Zbutton">
                <el-button type="primary" style="margin-left:15px;" @click="search">搜索</el-button>
                <el-button type="primary" @click="reset">重置</el-button>
              </el-form-item>
            </el-col>
      </el-row>

      <el-row style="width:700px;">
          <el-col :span="7">
              <el-form-item label="推广总收益：">{{this.totalPromotionRevenue}}</el-form-item>
          </el-col>
      </el-row>
    </el-form>
      <el-tabs type="card" v-model="activeName">
        <el-tab-pane label="推广收益" name="first">
              <el-table :data="tableData" border style="width: 100%;margin-top:15px;">
                <el-table-column prop="amazonOrderId" label="订单号" align="center"></el-table-column>
                <el-table-column prop="platformFee" label="平台费" align="center"></el-table-column>
                <el-table-column prop="promotionRatio" label="推广比例" align="center"></el-table-column>
                <el-table-column prop="promotionFee" label="推广收益" align="center"></el-table-column>
                <el-table-column prop="companyFullName" label="推广公司" align="center"></el-table-column>
                <el-table-column prop="recordTime" label="收益时间" align="center"></el-table-column>
              </el-table>

              <div class="page">
                  <el-pagination
                      style="margin-right:200px;"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-sizes="[20, 100, 200, 400]"
                      :page-size="pagesize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="total"
                  ></el-pagination>
              </div>
        </el-tab-pane>
        <el-tab-pane label="收益统计" name="second">
          <el-table :data="tableData1" border style="width: 100%;margin-top:15px;">
                <el-table-column prop="time" label="日期" align="center"></el-table-column>
                <el-table-column prop="quantityOfOrder" label="订单量" align="center"></el-table-column>
                <el-table-column prop="totalPlatformFee" label="平台费总计" align="center"></el-table-column>
                <el-table-column prop="totalPromotionFee" label="收益总计" align="center"></el-table-column>
              </el-table>

              <div class="page">
                  <el-pagination
                      style="margin-right:200px;"
                      @size-change="handleSizeChange1"
                      @current-change="handleCurrentChange1"
                      :current-page="currentPage1"
                      :page-sizes="[20, 100, 200, 400]"
                      :page-size="pagesize1"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="total1"
                  ></el-pagination>
              </div>
        </el-tab-pane>
      </el-tabs>

    <el-dialog title="增加汇款账号" :visible.sync="Reimbursement" width="25%">
            <el-form :model="form">
                <el-form-item label="银行" :label-width="formLabelWidth">
                    <el-input v-model="form.bank" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="开户支行" :label-width="formLabelWidth">
                    <el-input v-model="form.accountOpeningBranch" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="户名" :label-width="formLabelWidth">
                    <el-input v-model="form.accountName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="账号" :label-width="formLabelWidth">
                    <el-input v-model="form.accountNumber" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="Reimbursement = false">取消</el-button>
                <el-button type="primary" @click="AddSave">确定</el-button>
            </div>
    </el-dialog>

    <el-dialog title="编辑汇款账号" :visible.sync="ReimbursementEdit" width="25%">
            <el-form :model="form">
                <el-form-item label="银行" :label-width="formLabelWidth">
                    <el-input v-model="form.bank1" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="开户支行" :label-width="formLabelWidth">
                    <el-input v-model="form.accountOpeningBranch1" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="户名" :label-width="formLabelWidth">
                    <el-input v-model="form.accountName1" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="账号" :label-width="formLabelWidth">
                    <el-input v-model="form.accountNumber1" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="ReimbursementEdit = false">取消</el-button>
                <el-button type="primary" @click="EditSave">确定</el-button>
            </div>
    </el-dialog>

  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
    name: "Promotionrevenue",
    data() {
        return {
            activeName:"first",
            tableData:[],
            tableData1:[],
            company_List:[],
            options:[],
            accountData:"",
            formLabelWidth: "90px",
            numberOfPromotionCompanies:"",
            totalPromotionRevenue:"",
            ruleForm: {
                value:"",
                starttime: "", //开始时间
                endtime: "", //结束时间
            },
            form:{
              bank:"",
              accountOpeningBranch:"",
              accountName:"",
              accountNumber:"",

              bank1:"",
              accountOpeningBranch1:"",
              accountName1:"",
              accountNumber1:""
            },
            Reimbursement:false,
            ReimbursementEdit:false,
            loading:true,

            currentPage: 1,
            pagesize: 20,
            size: 20,
            total: 0,

            currentPage1: 1,
            pagesize1: 20,
            size1: 20,
            total1: 0,
        };
    },
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        this.companyList()
        this.search()
    },
    methods: {
      companyList(){
        var obj = {
          promoterId:this.str.rid
        }
        ajaxPost(Baseurl + "roleController/selectCompanyListByPromoterId",obj).then(res => {
              this.options = res.data
        });
      },
      search(){
        this.loading = true
        var obj = {
            rid:this.str.rid,
            companyId:this.ruleForm.value,
            startTime:this.ruleForm.starttime,
            endTime:this.ruleForm.endtime,
            page:this.currentPage,
            size:this.size
        }
        ajaxPost(Baseurl + "promotionRevenueRecordController/selectPromotionRevenueRecord",obj).then(res => {
            if(res.data.code == 200){
                this.tableData = res.data.data.promotionRevenues.list
                this.total = res.data.data.promotionRevenues.total

                this.tableData1 = res.data.data.incomeStatistics.list
                this.total1 = res.data.data.incomeStatistics.total

                this.accountData = res.data.data.remittanceAccount
                console.log(this.accountData)

                this.totalPromotionRevenue = res.data.data.totalPromotionRevenue
                this.numberOfPromotionCompanies = res.data.data.numberOfPromotionCompanies
            }else{
                this.$message.error(res.data.data);
            }
            this.loading = false
        });
      },
      reset(){
        this.ruleForm.value = ""
        this.ruleForm.starttime = ""
        this.ruleForm.endtime = ""
        this.search()
      },
      AddSave(){
        var obj = {
          bank:this.form.bank,
          accountOpeningBranch:this.form.accountOpeningBranch,
          accountName:this.form.accountName,
          accountNumber:this.form.accountNumber,
          promoterId:this.str.rid
        }
        ajaxPost(Baseurl + "remittanceAccountController/insertRemittanceAccountInfo",obj).then(res => {
            if(res.data.code == 200){
                this.$message({
                  message: '增加汇款账号成功',
                  type: 'success'
                });
                this.search()
            }else{
                this.$message.error(res.data.data);
            }
            this.Reimbursement = false;
        });
      },
      EditSave(){
        var obj = {
          id:this.accountData.id,
          bank:this.form.bank1,
          accountOpeningBranch:this.form.accountOpeningBranch1,
          accountName:this.form.accountName1,
          accountNumber:this.form.accountNumber1,
          promoterId:this.str.rid
        }
        ajaxPost(Baseurl + "remittanceAccountController/updateRemittanceAccountInfo",obj).then(res => {
            if(res.data.code == 200){
                this.$message({
                  message: '编辑汇款账号成功',
                  type: 'success'
                });
                this.search()
            }else{
                this.$message.error(res.data.data);
            }
            this.ReimbursementEdit = false;
        });
      },
      EditAccount(){
        this.ReimbursementEdit = true
        this.form.bank1 = this.accountData.bank
        this.form.accountOpeningBranch1 = this.accountData.accountOpeningBranch
        this.form.accountName1 = this.accountData.accountName
        this.form.accountNumber1 = this.accountData.accountNumber
      },
      //选择开始日期
        startDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 00:00:00";
            this.ruleForm.starttime = datetime;
        },
        //选择结束日期
        endDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 23:59:59";
            this.ruleForm.endtime = datetime;
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.size = val;
            this.search();
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search();
        },
        handleSizeChange1(val) {
            console.log(`每页 ${val} 条`);
            this.size1 = val;
            this.search();
        },
        handleCurrentChange1(val) {
            console.log(`当前页: ${val}`);
            this.currentPage1 = val;
            this.search();
        },
    }
}
</script>

<style lang="scss" scoped>
/deep/ {
    .Zbutton .el-form-item__content{
      margin-left: 0px!important;
    }
    .Forms .el-form-item__label{
      text-align: center;
    }
}
.Promotionrevenue{
  margin-bottom: 50px;
}
.page {
      position: fixed;
      width: 100%;
      bottom: 0;
      background-color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
}
</style>